import { Button, Grid, Typography, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import _isEmpty from 'lodash/isEmpty';
import UploadButton from '../journey/UploadButton';
import { MultipleErrorToast, generateVideoUrl } from '../utils/Utils';
import Image from '../common/Image';
import ZeroState from '../common/ZeroState';
import ExclamationIcon from '../../assets/ExclamationIcon';
import { CustomReactPlayer } from '../common/ReactPlayer';
import QuillRichTextEditor from '../common/QuillRichTextEditor';

const useStyles = makeStyles(() => ({
  templates: {
    height: '60vh',
    width: '97%',
    background: '#f3f4f7',
    padding: '15px 10px',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    overflowY: 'auto',
  },
  inputField: {
    width: '90%',
    padding: '15px 10px',
    borderRadius: '5px',
    border: '1px solid gray',
    outline: 'none',
    marginTop: '5px',
    background: 'transparent',
  },
  videoContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    width: '93%',
  },
  videoUrl: {
    width: '90%',
    height: '120px',
    padding: '15px 10px',
    borderRadius: '5px',
    border: '1px solid gray',
    outline: 'none',
    marginTop: '5px',
    background: 'transparent',
    resize: 'vertical',
  },

  upload: {
    border: '1px solid gray',
    padding: '10px',
    marginTop: '5px',
    width: '90%',
    borderRadius: '5px',
  },

  required_field: {
    color: '#667085',
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
  optional_field: {
    color: '#667085',
  },
}));

export default function VideoForm({
  setVideosImageUpdate,
  setThumbnailsList,
  videosList,
  imagdDataList,
  setImageDataList,
  videosImageUpdate,
  videosImageUpdateId,
  thumbnailList,
  thumbIndex,
  setVideosImageUpdateId,
  videoImageData,
  handleChangeForm,
  videoThumbnail,
  setVideoThumbnail,
  setVideoImageData,
  setVideosList,
  handleBack,
  clearState,
  editData,
  isAdd,
}) {
  const classes = useStyles();

  const INITIAL_VIDEO_FORM = {
    title: '',
    duration: '',
    link: '',
    av: null,
    overview: '',
  };
  const [videoForm, setVideoForm] = useState(INITIAL_VIDEO_FORM);
  const [decryptedURL, setDecryptedURL] = useState('');
  const [isValidUrl, setIsValidUrl] = useState('');

  useEffect(() => {
    if (editData) {
      setVideoForm(editData);
    }
    if (isAdd) {
      setVideoThumbnail('');
    }
  }, []);

  useEffect(() => {
    if (editData && editData.av && !_isEmpty(editData.av)) {
      const decodedUrl = generateVideoUrl(editData.av);
      setDecryptedURL(decodedUrl);
    }
  }, [editData]);

  useEffect(() => {
    if (editData && editData.av && videoForm.link === editData.av.url) {
      const decodedLink = generateVideoUrl(editData.av);
      setDecryptedURL(decodedLink);
    } else {
      setDecryptedURL(videoForm.link);
    }
    if (!videoForm.link) {
      setIsValidUrl(true);
    }
  }, [editData, videoForm.link]);

  const handleValidation = () => {
    let isCorrect = true;
    const errors = [];

    if (!videoForm.title) {
      isCorrect = false;
      errors.push('Please enter video title.');
    }
    if (!videoForm.duration) {
      isCorrect = false;
      errors.push('Please enter duration.');
    }
    if (videoForm.duration && Number.isNaN(Number(videoForm.duration))) {
      isCorrect = false;
      errors.push('Please enter a number for duration.');
    }
    if (!videoForm.link) {
      isCorrect = false;
      errors.push('Please enter a valid video link.');
    }
    if (!videoThumbnail) {
      isCorrect = false;
      errors.push('Please add a thumbnail.');
    }

    if (errors.length !== 0) {
      MultipleErrorToast(errors);
    }
    return isCorrect;
  };

  const handleVideoSave = () => {
    if (!handleValidation()) return;

    const videoData = {
      title: videoForm.title,
      duration: videoForm.duration,
      link: videoForm.link,
    };
    if (videoForm.overview) {
      videoData.overview = videoForm.overview;
    }

    if (videoForm.id) {
      setVideosList((prevVideos) =>
        prevVideos.map((video) => {
          if (video.id === videoForm.id) {
            videoData.id = videoForm.id;
            return { ...video, ...videoData };
          }
          return video;
        }),
      );

      if (videoImageData) {
        setVideosImageUpdate([...videosImageUpdate, videoImageData]);
        setVideosImageUpdateId([...videosImageUpdateId, videoForm.id]);
      }

      const temp2 = thumbnailList;
      temp2[thumbIndex] = videoThumbnail;
      setThumbnailsList(temp2);
    } else {
      const updateImg = imagdDataList[thumbIndex];
      if (!isAdd) {
        videosList?.splice(thumbIndex, 1);
        imagdDataList?.splice(thumbIndex, 1);
        thumbnailList?.splice(thumbIndex, 1);
      }
      setVideosList([...videosList, videoData]);
      if (videoImageData) {
        setImageDataList([...imagdDataList, videoImageData]);
      } else {
        setImageDataList([...imagdDataList, updateImg]);
      }

      setThumbnailsList([...thumbnailList, videoThumbnail]);
    }

    clearState();
  };

  const handleImageChange = (e) => {
    const filesData = e.target.files[0];
    setVideoImageData(filesData);
    const reader = new global.FileReader();
    reader.onload = (ev) => {
      setVideoThumbnail(ev.target.result);
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  return (
    <>
      <Grid className={classes.templates}>
        <Typography variant="h6">Add Video</Typography>
        <Grid>
          <Typography className={classes.required_field}>Video Title</Typography>
          <input
            placeholder="ex: EV Roadtrip"
            className={classes.inputField}
            value={videoForm.title}
            onChange={(e) => handleChangeForm(e, 'title', videoForm, setVideoForm)}
          />
        </Grid>
        <Grid>
          <Typography className={classes.required_field}>Thumbnail (max size - 100kb) </Typography>
          <Grid className={classes.upload}>
            <Grid container direction="row" justifyContent="space-between" alignItems="center">
              <Grid style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                <Image alt="" src={videoThumbnail || ''} style={{ height: '26px' }} loading="lazy" />
              </Grid>
              <Grid>
                <UploadButton
                  disableElevation
                  className={classes.btnUploadStyle}
                  handleImageUpload={handleImageChange}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid className={classes.videoContainer}>
          <Grid style={{ width: '50%', height: '200px' }}>
            <Typography className={classes.required_field}>Video Link </Typography>
            <textarea
              placeholder="Enter video link here"
              className={classes.videoUrl}
              value={videoForm.link}
              onChange={(e) => {
                handleChangeForm(e, 'link', videoForm, setVideoForm);
              }}
            />
          </Grid>
          <Grid
            style={{
              width: '50%',
              height: '200px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {decryptedURL ? (
              <CustomReactPlayer
                url={decryptedURL}
                width="100%"
                height="90%"
                onError={() => {
                  setDecryptedURL('');
                  setIsValidUrl(false);
                }}
              />
            ) : (
              <ZeroState
                Icon={ExclamationIcon}
                text={
                  isValidUrl
                    ? 'Add video link for the video preview to be visible'
                    : 'Not able to render the video. Please verify if video URL is valid.'
                }
                style={{ width: '100%', height: '170px' }}
                type="video"
                iconColor={isValidUrl ? '#98A2B3' : '#D92D20'}
              />
            )}
          </Grid>
        </Grid>
        <Grid>
          <Typography className={classes.required_field}>Duration (in seconds) </Typography>
          <input
            placeholder="Enter duration here"
            className={classes.inputField}
            value={videoForm.duration}
            onChange={(e) => handleChangeForm(e, 'duration', videoForm, setVideoForm)}
          />
        </Grid>
        <Grid>
          <Typography className={classes.optional_field}>Video Overview </Typography>
          <Grid item style={{ marginTop: '5px' }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="center">
              <Grid item style={{ width: '94%' }}>
                <QuillRichTextEditor
                  value={videoForm.overview}
                  changeFn={(e) =>
                    setVideoForm({
                      ...videoForm,
                      overview: e,
                    })
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid style={{ display: 'flex' }}>
        <Button onClick={handleBack} variant="outlined">
          Back
        </Button>
        <Grid container direction="row" justifyContent="flex-end" alignItems="center">
          <Button variant="contained" color="primary" onClick={handleVideoSave}>
            Continue
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
